import React from 'react';
import Image from '../../../img/MainWebsite/OurMenus.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function OurMenus() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent whiteFont'}>
        <div className={'column'}>
          <h3 className={'green left'}> Supplemental Digital Menus Designed Around Your Brand
          </h3>
          <h5 className={'left'}> Vizo Menu gives businesses a flexible way to present menus, products, services, promotions, and sponsor placements in a clean,
            organized digital format.  </h5>
          <h5 className={'left'}> The platform is designed to supplement your existing menus and operations, not replace them.  </h5>
          <h5 className={'left'}> Your brand remains front and center. Vizo Menu works behind the scenes to make your offerings easier to browse, understand, and
            promote.   </h5>

          <h3 className={'green left'}> What Vizo Menu Can Present  </h3>
          <h5 className={'left'}> Vizo Menu can be customized to showcase food and beverage menus, retail products, services, and promotions with:  </h5>
          <ul className={"two-columns"}>
            <li className={'green left'}><h5>  Vivid imagery  </h5></li>
            <li className={'green left'}><h5> Enticing descriptions   </h5></li>
            <li className={'green left'}><h5> Helpful allergy notes, when applicable   </h5></li>
            <li className={'green left'}><h5>  Trusted expert ratings help customers make confident decisions, when applicable  </h5></li>

          </ul>
          <h5 className={'left'}> Each digital menu is custom-built around the client’s offerings, brand, and operational needs, with flexible organization by category,
            outlet, service area, or business purpose.  </h5>

          <h3 className={'green left'}> Built for Clarity  </h3>
          <h5 className={'left'}>When customers can quickly understand what is available, they are more likely to explore more offerings, ask fewer repetitive
            questions, and move forward with less hesitation.   </h5>
          <h5 className={'left'}> Vizo Menu helps businesses present important details in a clean, organized format that supports the customer experience without
            adding unnecessary complexity for staff.  </h5>

          <h3 className={'green left'}>Flexible and Easy to Update   </h3>
          <h5 className={'left'}> Vizo Menu is built to stay current as your offerings change.  </h5>
          <h5 className={'left'}>The platform supports:   </h5>
          <ul className={"two-columns"}>
            <li className={'green left'}><h5>  Unlimited menu items and categories  </h5></li>
            <li className={'green left'}><h5> Unlimited in-house promotions   </h5></li>
            <li className={'green left'}><h5> Unlimited updates and revisions   </h5></li>
            <li className={'green'}><h5> Multiple outlets or service areas   </h5></li>
            <li className={'green left'}><h5> Brand-specific presentation   </h5></li>
          </ul>
          <h5 className={'left'}> This gives businesses the flexibility to adjust menus, promotions, services, and featured items without reprinting materials or
            rebuilding the customer experience.  </h5>

          <h3 className={'green left'}> Designed to Stay Out of the Way  </h3>
          <h5 className={'left'}>Vizo Menu is discreet by design.   </h5>
          <h5 className={'left'}>Customers engage with your brand, your offerings, and your presentation. The digital experience is designed to feel like an extension
            of your business — not a third-party platform taking attention away from you.   </h5>

          <h3 className={'green left'}> Simple Access  </h3>
          <h5 className={'left'}>Customers can access Vizo Menu from their own phone or tablet.   </h5>
          <h5 className={'left'}>The goal is simple: make it easier for customers to explore what you offer.  </h5>

          <h3 className={'green left'}> Better Presentation. Better Engagement.
          </h3>
          <h5 className={'left'}> Vizo Menu helps businesses present their offerings clearly, consistently, and professionally.
          </h5>
          <h5 className={'left'}>When information is easy to access and understand, customers explore more, staff spend less time clarifying basic details, and the
            overall experience becomes smoother.   </h5>


        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background green-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO

          </button>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default OurMenus;